import React from 'react';

export function StepLocationLabel() {
  return <>Adresa, Poloha</>;
}
